// Référentiel des nationalités en français (forme féminine, usage administratif).
// La France est volontairement placée en première position. Les autres sont
// triées alphabétiquement.
//
// Cette liste sert de source unique pour :
// - le composant <NationalitySelect /> à l'inscription et dans le backoffice
// - la migration de backfill côté backend (cf. routes/maintenance.py)
//
// Pour ajouter une nationalité : ajouter une entrée dans NATIONALITIES_REST en
// conservant l'ordre alphabétique. Pour ajouter un mapping pays -> nationalité
// (utilisé pour le backfill et la déduction depuis id_doc_origin), ajouter
// l'entrée dans COUNTRY_TO_NATIONALITY ci-dessous.

export const FRANCE = "Française";

const NATIONALITIES_REST = [
  "Afghane", "Albanaise", "Algérienne", "Allemande", "Américaine", "Andorrane",
  "Angolaise", "Argentine", "Arménienne", "Australienne", "Autrichienne",
  "Azerbaïdjanaise", "Bahreïnienne", "Bangladaise", "Belge", "Béninoise",
  "Biélorusse", "Birmane", "Bolivienne", "Bosniaque", "Brésilienne",
  "Britannique", "Bulgare", "Burkinabée", "Burundaise", "Cambodgienne",
  "Camerounaise", "Canadienne", "Cap-Verdienne", "Centrafricaine",
  "Chilienne", "Chinoise", "Chypriote", "Colombienne", "Comorienne",
  "Congolaise", "Congolaise (RDC)", "Coréenne du Nord", "Coréenne du Sud",
  "Costaricaine", "Croate", "Cubaine", "Danoise", "Djiboutienne",
  "Dominicaine", "Égyptienne", "Émirienne", "Équatorienne", "Érythréenne",
  "Espagnole", "Estonienne", "Éthiopienne", "Fidjienne", "Finlandaise",
  "Gabonaise", "Gambienne", "Géorgienne", "Ghanéenne", "Grecque",
  "Guatémaltèque", "Guinéenne", "Guinéenne-Bissau", "Guyanienne", "Haïtienne",
  "Hondurienne", "Hongroise", "Indienne", "Indonésienne", "Irakienne",
  "Iranienne", "Irlandaise", "Islandaise", "Israélienne", "Italienne",
  "Ivoirienne", "Jamaïcaine", "Japonaise", "Jordanienne", "Kazakhstanaise",
  "Kényane", "Kirghize", "Kosovare", "Koweïtienne", "Laotienne", "Lesothane",
  "Lettonne", "Libanaise", "Libérienne", "Libyenne", "Liechtensteinoise",
  "Lituanienne", "Luxembourgeoise", "Macédonienne", "Malaisienne", "Malawite",
  "Maldivienne", "Malgache", "Malienne", "Maltaise", "Marocaine", "Marshallaise",
  "Mauricienne", "Mauritanienne", "Mexicaine", "Micronésienne", "Moldave",
  "Monégasque", "Mongole", "Monténégrine", "Mozambicaine", "Namibienne",
  "Nauruane", "Néerlandaise", "Néo-Zélandaise", "Népalaise", "Nicaraguayenne",
  "Nigériane", "Nigérienne", "Norvégienne", "Omanaise", "Ougandaise",
  "Ouzbèke", "Pakistanaise", "Palaosienne", "Palestinienne", "Panaméenne",
  "Papouasienne", "Paraguayenne", "Péruvienne", "Philippine", "Polonaise",
  "Portugaise", "Qatarienne", "Roumaine", "Russe", "Rwandaise", "Saint-Lucienne",
  "Saint-Marinaise", "Saint-Vincentaise", "Salomonaise", "Salvadorienne",
  "Samoane", "Santoméenne", "Saoudienne", "Sénégalaise", "Serbe", "Seychelloise",
  "Sierra-léonaise", "Singapourienne", "Slovaque", "Slovène", "Somalienne",
  "Soudanaise", "Sri-lankaise", "Sud-africaine", "Sud-soudanaise", "Suédoise",
  "Suisse", "Surinamaise", "Swazie", "Syrienne", "Tadjike", "Taïwanaise",
  "Tanzanienne", "Tchadienne", "Tchèque", "Thaïlandaise", "Timoraise",
  "Togolaise", "Tongienne", "Trinidadienne", "Tunisienne", "Turkmène", "Turque",
  "Tuvaluane", "Ukrainienne", "Uruguayenne", "Vanuatuane", "Vaticane",
  "Vénézuélienne", "Vietnamienne", "Yéménite", "Zambienne", "Zimbabwéenne",
];

// France first, then alphabetical rest. (Liste affichée dans le combobox.)
export const NATIONALITIES = [FRANCE, ...NATIONALITIES_REST];

// Mapping pays (libellé tel qu'il apparaît dans id_doc_origin) -> nationalité
// (forme féminine). Utilisé par le backfill côté backend. Insensible à la
// casse. Couvre les ~75 pays les plus courants.
export const COUNTRY_TO_NATIONALITY = {
  "france": "Française",
  "afghanistan": "Afghane",
  "afrique du sud": "Sud-africaine",
  "albanie": "Albanaise",
  "algerie": "Algérienne",
  "algérie": "Algérienne",
  "allemagne": "Allemande",
  "angola": "Angolaise",
  "arabie saoudite": "Saoudienne",
  "argentine": "Argentine",
  "armenie": "Arménienne",
  "arménie": "Arménienne",
  "australie": "Australienne",
  "autriche": "Autrichienne",
  "bangladesh": "Bangladaise",
  "belgique": "Belge",
  "benin": "Béninoise",
  "bénin": "Béninoise",
  "bosnie": "Bosniaque",
  "bosnie-herzegovine": "Bosniaque",
  "bresil": "Brésilienne",
  "brésil": "Brésilienne",
  "bulgarie": "Bulgare",
  "burkina faso": "Burkinabée",
  "cambodge": "Cambodgienne",
  "cameroun": "Camerounaise",
  "canada": "Canadienne",
  "cap-vert": "Cap-Verdienne",
  "cap vert": "Cap-Verdienne",
  "chili": "Chilienne",
  "chine": "Chinoise",
  "colombie": "Colombienne",
  "comores": "Comorienne",
  "congo": "Congolaise",
  "congo brazzaville": "Congolaise",
  "congo (rdc)": "Congolaise (RDC)",
  "rdc": "Congolaise (RDC)",
  "republique democratique du congo": "Congolaise (RDC)",
  "république démocratique du congo": "Congolaise (RDC)",
  "coree du sud": "Coréenne du Sud",
  "corée du sud": "Coréenne du Sud",
  "cote d'ivoire": "Ivoirienne",
  "côte d'ivoire": "Ivoirienne",
  "croatie": "Croate",
  "cuba": "Cubaine",
  "danemark": "Danoise",
  "egypte": "Égyptienne",
  "égypte": "Égyptienne",
  "espagne": "Espagnole",
  "estonie": "Estonienne",
  "etats-unis": "Américaine",
  "états-unis": "Américaine",
  "usa": "Américaine",
  "ethiopie": "Éthiopienne",
  "éthiopie": "Éthiopienne",
  "finlande": "Finlandaise",
  "gabon": "Gabonaise",
  "ghana": "Ghanéenne",
  "grece": "Grecque",
  "grèce": "Grecque",
  "guinee": "Guinéenne",
  "guinée": "Guinéenne",
  "haiti": "Haïtienne",
  "haïti": "Haïtienne",
  "hongrie": "Hongroise",
  "inde": "Indienne",
  "indonesie": "Indonésienne",
  "indonésie": "Indonésienne",
  "iran": "Iranienne",
  "irak": "Irakienne",
  "irlande": "Irlandaise",
  "israel": "Israélienne",
  "israël": "Israélienne",
  "italie": "Italienne",
  "japon": "Japonaise",
  "jordanie": "Jordanienne",
  "kosovo": "Kosovare",
  "laos": "Laotienne",
  "lettonie": "Lettonne",
  "liban": "Libanaise",
  "libye": "Libyenne",
  "lituanie": "Lituanienne",
  "luxembourg": "Luxembourgeoise",
  "macedoine": "Macédonienne",
  "macédoine": "Macédonienne",
  "madagascar": "Malgache",
  "malaisie": "Malaisienne",
  "mali": "Malienne",
  "malte": "Maltaise",
  "maroc": "Marocaine",
  "maurice": "Mauricienne",
  "ile maurice": "Mauricienne",
  "île maurice": "Mauricienne",
  "mauritanie": "Mauritanienne",
  "mexique": "Mexicaine",
  "moldavie": "Moldave",
  "mozambique": "Mozambicaine",
  "nepal": "Népalaise",
  "népal": "Népalaise",
  "niger": "Nigérienne",
  "nigeria": "Nigériane",
  "nigéria": "Nigériane",
  "norvege": "Norvégienne",
  "norvège": "Norvégienne",
  "nouvelle-zelande": "Néo-Zélandaise",
  "nouvelle-zélande": "Néo-Zélandaise",
  "pakistan": "Pakistanaise",
  "palestine": "Palestinienne",
  "panama": "Panaméenne",
  "paraguay": "Paraguayenne",
  "pays-bas": "Néerlandaise",
  "perou": "Péruvienne",
  "pérou": "Péruvienne",
  "philippines": "Philippine",
  "pologne": "Polonaise",
  "portugal": "Portugaise",
  "republique dominicaine": "Dominicaine",
  "république dominicaine": "Dominicaine",
  "republique tcheque": "Tchèque",
  "république tchèque": "Tchèque",
  "roumanie": "Roumaine",
  "royaume-uni": "Britannique",
  "royaume uni": "Britannique",
  "uk": "Britannique",
  "angleterre": "Britannique",
  "russie": "Russe",
  "rwanda": "Rwandaise",
  "salvador": "Salvadorienne",
  "el salvador": "Salvadorienne",
  "senegal": "Sénégalaise",
  "sénégal": "Sénégalaise",
  "serbie": "Serbe",
  "sierra leone": "Sierra-léonaise",
  "slovaquie": "Slovaque",
  "slovenie": "Slovène",
  "slovénie": "Slovène",
  "somalie": "Somalienne",
  "soudan": "Soudanaise",
  "sri lanka": "Sri-lankaise",
  "suede": "Suédoise",
  "suède": "Suédoise",
  "suisse": "Suisse",
  "syrie": "Syrienne",
  "tchad": "Tchadienne",
  "thailande": "Thaïlandaise",
  "thaïlande": "Thaïlandaise",
  "togo": "Togolaise",
  "tunisie": "Tunisienne",
  "turquie": "Turque",
  "ukraine": "Ukrainienne",
  "uruguay": "Uruguayenne",
  "venezuela": "Vénézuélienne",
  "vietnam": "Vietnamienne",
  "yemen": "Yéménite",
  "yémen": "Yéménite",
  "zambie": "Zambienne",
  "zimbabwe": "Zimbabwéenne",
};

// Lookup case-insensitif (utile côté frontend pour la validation).
const NORM = (s) => (s || "").toString().trim().toLowerCase();

export function isValidNationality(value) {
  const v = NORM(value);
  return NATIONALITIES.some((n) => NORM(n) === v);
}

export function isFrench(value) {
  return NORM(value) === NORM(FRANCE);
}
